import { api } from '../../../api';
import { BusinessDocTypeViewModel } from '../../ViewModels/BusinessDocTypeViewModel';
import { ApiResponse } from '../../Utilities';
import { RecursivePartial } from '../../../../types';

export class BusinessDocTypeApi {
    private route = '/BusinessDocType';

    getBusinessDocType(params: {
        businessDocTypeId?: number;
        businessDocSubTypeId?: number;
        companyId?: number;
        $filter?: string;
        $orderBy?: string;
        $skip?: number;
        $top?: number;
    }): ApiResponse<BusinessDocTypeViewModel[]> {
        return api().get(this.route, { params });
    }

    postBusinessDocType(body: RecursivePartial<BusinessDocTypeViewModel>): ApiResponse<{ ID: number; SubID: number }> {
        return api().post(this.route, body);
    }

    putBusinessDocType(
        params: {
            businessDocTypeId: number;
            businessDocSubTypeId: number;
        },
        body: RecursivePartial<BusinessDocTypeViewModel>
    ): ApiResponse<BusinessDocTypeViewModel> {
        return api().put(this.route, body, { params });
    }

    deleteBusinessDocType(params: {
        businessDocTypeId: number;
        businessDocSubTypeId: number;
    }): ApiResponse<{ ID: number; SubID: number }> {
        return api().delete(this.route, { params });
    }

    /**
     * Generate a skeleton XML from a delimited file (CSV, TXT, etc.)
     * Uses the DelimitedToXML pipeline to convert the file to skeleton format.
     */
    generateSkeleton(file: File): ApiResponse<string> {
        const formData = new FormData();
        formData.append('file', file);

        return api().post(`${this.route}/GenerateSkeleton`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}
